import React from "react";

function AccidentForm() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden; /* Hide all elements on the page by default */
            }
            #AccidentForm, #AccidentForm * {
              visibility: visible; /* Make only the form and its children visible */
              color: black !important; /* Ensure text is black for printing */
            }
            #AccidentForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide the print button when printing */
            .print-button {
              display: none;
            }
            /* Ensure input fields are visible and readable when printed */
            input, textarea {
                border: 1px solid #000;
            }
          }
        `}
      </style>
      <div id="AccidentForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Vehicle Accident / Incident Report</h3>

        <form>
          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="vehicleRegistration">
              Vehicle Registration:
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Date of Incident */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="incidentDate">
              Date of Incident:
            </label>
            <input
              type="date"
              id="incidentDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Reported By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="reportedBy">
              Reported By (Name):
            </label>
            <input
              type="text"
              id="reportedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name of person reporting"
            />
          </div>

          {/* Incident Type */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Incident Type:</label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Accident</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Near Miss</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Other</span>
              </label>
            </div>
          </div>

          {/* Description of Incident */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="incidentDescription">
              Description of Incident:
            </label>
            <textarea
              id="incidentDescription"
              className="p-3 border border-gray-300 rounded-lg w-full h-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the incident in detail"
            />
          </div>

          {/* Action Taken */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="actionTaken">
              Action Taken:
            </label>
            <textarea
              id="actionTaken"
              className="p-3 border border-gray-300 rounded-lg w-full h-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe any immediate actions taken"
            />
          </div>

          {/* Follow-up Actions Required */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="followUpActions">
              Follow-up Actions Required:
            </label>
            <textarea
              id="followUpActions"
              className="p-3 border border-gray-300 rounded-lg w-full h-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe any follow-up actions required"
            />
          </div>

          {/* Witnesses */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Witnesses:</label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">No</span>
              </label>
            </div>
            <input
              type="text"
              id="witnessDetails"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Witness details (if applicable)"
            />
          </div>

          {/* Other Parties Involved */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Other Parties Involved:</label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">No</span>
              </label>
            </div>
            <input
              type="text"
              id="otherPartyDetails"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Other party details (if applicable)"
            />
          </div>

          {/* Damage Assessment */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="damageAssessment">
              Damage Assessment:
            </label>
            <textarea
              id="damageAssessment"
              className="p-3 border border-gray-300 rounded-lg w-full h-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe any damage to vehicles, property, or persons"
            />
          </div>

          {/* Actions Taken to Rectify */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="actionsTakenToRectify">
              Actions Taken to Rectify:
            </label>
            <textarea
              id="actionsTakenToRectify"
              className="p-3 border border-gray-300 rounded-lg w-full h-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe any actions taken to rectify the situation"
            />
          </div>

          {/* Insurance Details */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Insurance Details:</label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">No</span>
              </label>
            </div>
            <input
              type="text"
              id="insuranceClaimNumber"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Insurance Claim Number (if applicable)"
            />
          </div>

          {/* Driver Condition Before Incident */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Driver Condition Before Incident:</label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Fit</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Unfit</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Fatigued</span>
              </label>
              <input
                type="text"
                id="otherConditionBefore"
                className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Other (specify)"
              />
            </div>
          </div>

          {/* Driver Condition After Incident */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Driver Condition After Incident:</label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Fit</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Unfit</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Fatigued</span>
              </label>
              <input
                type="text"
                id="otherConditionAfter"
                className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Other (specify)"
              />
            </div>
          </div>

          {/* Signatures */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverSignature">
              Signature of Driver:
            </label>
            <input
              type="text"
              id="driverSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Driver's signature"
            />
          </div>

          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="thirdPartySignature">
              Signature of Third Party (if applicable):
            </label>
            <input
              type="text"
              id="thirdPartySignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Third party signature"
            />
          </div>

          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managerSignature">
              Signature of Manager:
            </label>
            <input
              type="text"
              id="managerSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Manager's signature"
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default AccidentForm;